import React from 'react';
import {
    Card,
    CardBody,
    Container,
    Table
} from 'reactstrap';
import Loader from 'commonComponents/Loader';
import AddBanner from './AddBanner';
import ShowBanner from './ShowBanner';


const AdminSetting = () => {
    return (
        <>
            <Container fluid className="mt-4" >
                <Card className=" w-100" >
                    <CardBody >
                        <Table className="align-items-center table-flush" responsive >

                            <tbody>
                                <AddBanner />
                                <hr />
                                <Container fluid >
                                    <h1 style={{ color: '#135674' }}>Slider Preview</h1>
                                </Container>
                                <ShowBanner />

                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
};

export default AdminSetting;
